module.exports = __webpack_public_path__ + "img/tech5small.8bb4ae13.jpg";